var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("bulma-autocomplete", {
    attrs: {
      placeholder: "Suburb",
      data: _vm.suburbs.data,
      field: "suburb",
      loading: _vm.suburbs.loading,
    },
    on: {
      input: function ($event) {
        return _vm.searchSuburb($event)
      },
      select: function ($event) {
        return _vm.pickSuburb($event)
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (props) {
          return [
            _c("div", [
              _c("span", { staticClass: "icon is-small" }, [
                _c("i", { staticClass: "mdi mdi-map-marker" }),
              ]),
              _vm._v(
                " " +
                  _vm._s(
                    `${props.option.suburb}, ${props.option.state}, ${props.option.country}`
                  ) +
                  " "
              ),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.suburb,
      callback: function ($$v) {
        _vm.suburb = $$v
      },
      expression: "suburb",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }